'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localeContext = localeContext;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function localeContext(name, defaultLocale) {
  return function (BaseComponent) {
    BaseComponent.contextTypes = Object.assign(BaseComponent.contextTypes || {}, { antLocale: _propTypes2.default.object, app: _propTypes2.default.object });

    BaseComponent.prototype.getLocale = function (key) {
      var locale = void 0;
      if (this.context.locale) {
        locale = this.context.locale;
      } else {
        locale = this.context.locale = Object.assign(this.context.antLocale && this.context.antLocale[name] || {}, defaultLocale, this.props && this.props.locale);
      }
      if (key) {
        return locale[key];
      } else {
        return locale;
      }
    };
    return BaseComponent;
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/core/localeContext.js
// module id = 3
// module chunks = 0